import msg from './message'
import tabelaPreco from './precos'
// Create = C
const create = async () => {
  // const pedidoAtual = await tabelaPreco.filter(pedido => pedido.descricao === itemPedido.pedido)
  // pedidoAtual.forEach((pedido) => {
  //   itemPedido.preco = pedido.preco
  //   itemPedido.subtotal = Number(pedido.preco * itemPedido.qtde)
  // })
  const request = indexedDB.open("meusPedidos", 3)
  request.onsuccess = function(event) {
    // Fazer algo com request.result!
    const db = request.result
    const transaction = db.transaction(["pedidos"],"readwrite")
    const objectStore = transaction.objectStore("pedidos")
    try {
      if (tabelaPreco.length > 1) {
        for (var i in tabelaPreco) {
          objectStore.add(tabelaPreco[i]);
        }
      }
       transaction.oncomplete = function(event){
         // console.log('pedido cadastrado: ', itemPedido);
         // const message = `Pedido adicionado.`
         // showMessage("strong", "venda-message", message, 3000)
         // resetForm("form-cadastrar-venda", "#cadastrar-venda")
       }
    } catch (e) {
      // console.log('err ', e);
      // const message = `Erro ao cadastrar a venda.
      // Preencha os dados: código, quantidade e preço.`
      // showMessage("strong", "venda-message", message, 5000)
    }
  }
}
// update
const update = (index, qtdeUpdate) => {
  const idForUpdate = index + 1
  // console.log(idForUpdate);
  const request = indexedDB.open("meusPedidos", 3);
  // console.log('request ', request);
  request.onsuccess = function(event) {
    const db = request.result
    const objectStore = db.transaction(["pedidos"], "readwrite").objectStore("pedidos")
    // Tratando erro de chave não informada
    if (idForUpdate && qtdeUpdate ) {
      // console.log('ok')
      const req = objectStore.get(idForUpdate)
      req.onsuccess = function(event) {
        // Obter os valores antigos
        const data = req.result
        if (qtdeUpdate) {
          data.qtde = qtdeUpdate
          data.subtotal = qtdeUpdate * data.preco
        }
        // Atualizar esse dado no banco
         const requestUpdate = objectStore.put(data)
         requestUpdate.onsuccess = function(event) {
           // Sucesso na atualização \o/
         }
      }
    }else {
      // const message = `Informe os campos. Exemplo:
      //   codigo, preco ou qtde.`
      // showMessage("li", "update-message", message, 5000)
    }
  }
}
// Read = R
const readPedido = () => {
  const request = indexedDB.open("meusPedidos", 3)
  let sendZap = {}
  // array mensagem/url zap
  let zapMessage = ['url']
  request.onsuccess = function(event) {
    // Fazer algo com request.result!
    const db = request.result
    const transaction = db.transaction(["pedidos"])
    const objectStore = transaction.objectStore("pedidos")
    // const req = objectStore.get(idForSearch)
    const reqAll = objectStore.getAll()
    reqAll.onsuccess = function(event) {
      const pedidos = reqAll.result
      // console.log('resultPedidos ', resultPedidos)
      let joinSubtotal = []
      // Apresentando lista de vendas requisitada pelo usuário
      for (var i = 0; i < pedidos.length; i++) {
        // Preenchendo array que irá gerar o total de vendas
        let newArray = Number(pedidos[i].subtotal)
        joinSubtotal.push(newArray)
        // console.log('pedidos ', pedidos);
        let preco = ((pedidos[i].preco).toFixed(2))
        let subtotal = pedidos[i].subtotal
        let pedidoOn = `ID: ${pedidos[i].id} - Descrição ${pedidos[i].descricao} -
        Qtde ${pedidos[i].qtde} - Preço ${new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(preco)} -
        subtotal ${new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
          .format(subtotal)}`
        const totalPedido = joinSubtotal.reduce((a,b) => a + b)
        let pedidOf = ''
        let message = totalPedido > 0 ? pedidoOn : pedidOf
        let prop = pedidos[i].name
        sendZap.prop = message
      }
    }
  }
  // console.log('sendZap ', sendZap);
}
export default { create, update, readPedido}
